import Header from "./header";
import Resumes from "./resumes/resumes";
import Navbar from "../../components/templates/navbar";
import Footer from "../../components/templates/footer";
import { useEffect, useState } from "react";
import { search_Resumes } from "./helper";
import { showToast } from "../../utils/commonHelper";
import axios from "axios";
import { useResumeFetcher } from "../../hooks/useResumeFetcher";
const Library = () => {
  const { getResumes, resumesData, isLoading } = useResumeFetcher();

  console.log("resumes", resumesData);
  useEffect(() => {
    getResumes();
  }, []);
  return (
    <div>
      <Navbar />
      <Header
        onSearch={(jobTitle) => getResumes({ job_title: jobTitle })}
        careerLevelChange={(carrerLevel) => {
          if (carrerLevel === "All") {
            getResumes({ career_level: "" });
          } else {
            getResumes({ career_level: carrerLevel });
          }
        }}
        onIndustryChange={(industry) => {
          if (industry === "All") {
            getResumes({ industry: "" });
          } else {
            getResumes({ industry: industry });
          }
        }}
        onRegionChange={(region) => getResumes({ region: region })}
      />
      <Resumes
        isLoading={isLoading}
        resumesData={resumesData}
        onPageChange={(newPage) => {
          getResumes({ page: newPage });
        }}
        onFamilyChange={(plan) => {
          getResumes({
            job_family: plan.job_family === "All" ? "" : plan.job_family,
          });
        }}
      />
      <Footer />
    </div>
  );
};

export default Library;
